import { Button } from '@material-ui/core';
import { GridRowId } from '@material-ui/data-grid';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import { RootStateType } from '../../../../redux-store/reducers';
import { IsAllow, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { REDEMPTION } from '../../../../utils/constants';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { getMatchAndUnMatchedFunds } from '../../../../utils/utilityFunctions';
import { NomineeStatusErrorRef, NomineeStatusError } from '../../../common/NomineeStatusError';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { getDividendFilteredData, getErrorMessage } from '../../portfolios/utils';
import { ActionHeader, FaqLink } from '../index';
import { swpFilters } from '../Switch/utils';

export interface DividendTableRowType extends SCHEMES_RESPONSE {
    id?: GridRowId;
    isDisabled?: boolean;
}

const { dbCommercial, dashboard } = en;

const columns: TableColumn[] = [
    { field: 'folio', headerName: 'Folio', width: 150 },
    {
        field: 'id',
        headerName: 'Scheme Name',
        valueGetter: ({ row }) => `${row?.amcName}-${row?.schemeName}`,
        width: 350,
        filterBy: true,
        filterHeader: 'AMC',
        filterKey: 'amcName',
        fullWidth: true,
    },
    {
        field: 'availableAmount',
        headerName: 'Available Amount',
        width: 220,
        valueGetter: ({ row }) => formatAsIndianCurrency(row?.availableAmount),
    },
    {
        field: 'availableUnits',
        headerName: 'Available Units',
        width: 220,
        valueGetter: ({ row }) => row?.availableUnits,
    },
];

function SWP(props: any) {
    const [rowData, setRowData] = useState<DividendTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { portfolios = {} } = props;
    const { data: folioList = [] } = portfolios;
    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<DividendTableRowType[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns,
        loading,
    });
    const nomineeErrorRef = useRef<NomineeStatusErrorRef>(null);

    useEffect(() => {
        setLoading(true);
        async function fetchPortfolio() {
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            try {
                await props.getPortfolio({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                });
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        fetchPortfolio();
    }, []);

    useEffect(() => {
        const schemeOptionsData = getDividendFilteredData(folioList);
        const data = getMatchAndUnMatchedFunds(swpFilters, schemeOptionsData, true);
        setRowData(data);
    }, [props.portfolios]);

    const handleSubmit = async () => {
        // if (![IsAllow.YES, 'O'].includes(selectedRows[0]?.nomineeStatus?.toUpperCase())) {
        //     nomineeErrorRef.current?.showNomineeError();
        // } else {
        try {
            props.history.push(`swp/${selectedRows[0].isin}?amc=${selectedRows[0].amc}`, {
                swpFolio: selectedRows[0],
            });
        } catch (err: any) {
            alert(err.message);
        }
        // }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.swp.heading} />
            {/* <NomineeStatusError ref={nomineeErrorRef} /> */}
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <>
                        <h5> {dbCommercial.swp.swpDetails}</h5>
                        {!!loading || tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={(params) => (params.row.isDisabled ? false : true)}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                toolTipTextGetter={({ row }) => getErrorMessage(row, swpFilters)}
                                toolTipEnabled
                                radioGroupsEnabled
                                resetFilters={resetFilters}
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound info={'No Folios Found'} />
                        )}
                    </>
                    {/* <FaqLink section={REDEMPTION} /> */}
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <Button
                                className="customBtn"
                                disabled={!selectedRows.length}
                                onClick={handleSubmit}
                            >
                                {dashboard.ChangeDividend.buttonText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, sendPhoneOTP },
)(SWP);
